import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { Service } from "../service.class";
import { CustomerModel } from "../../../shared/entities/customer.model";
import { CustomerModelLite } from "../../../shared/entities/customer-lite.model";
import { ENVIRONMENT } from "../../token";

@Injectable()
export class UserModelService {
	private serverPath: string = "/v2/customers";

	constructor(@Inject(ENVIRONMENT) protected environment, private service: Service) {}

	public getUserRequestURL(): string {
		return this.environment.url_requests;
	}

	public getUserRequestLiteURL(): string {
		return this.environment.url_collab_requests;
	}

	public postCustomerModel(customer: CustomerModel): Observable<CustomerModel> {
		const url = this.getUserRequestURL();
		return this.service.apiPostUserRequest(url, customer);
	}

	public postCustomerModelLite(customer: CustomerModelLite): Observable<CustomerModelLite> {
		const url = this.getUserRequestLiteURL();
		return this.service.apiPostUserRequest(url, customer);
	}

	public getCustomerModelById(id: string): Observable<CustomerModel> {
		return this.service.apiGetWithoutHeaders(this.serverPath + "/" + id, {
			paginate: false,
		});
	}
	public deleteCustomerModelById(id: string): Observable<CustomerModel> {
		return this.service.apiDelete(this.serverPath + "/" + id);
	}
	public getCustomersModels(): Observable<CustomerModel> {
		return this.service.apiGetWithoutHeaders(this.serverPath, {
			paginate: true,
		});
	}

	public updateCustomerModelById(id: string, customer: CustomerModel): Observable<CustomerModel> {
		return this.service.apiPut(this.serverPath + "/" + id, customer);
	}

	public resendEmail(_id: string): Observable<unknown> {
		return this.service.apiPut(this.serverPath + "/resend-email/" + _id, {});
	}
}
